import { Heading } from '@chakra-ui/react'

export default Heading
